module.exports = __webpack_public_path__ + "static/img/main-privacy__icon.ee1c8d2e.svg";